import { render, staticRenderFns } from "./UpdateRule.vue?vue&type=template&id=61871523&scoped=true"
import script from "./UpdateRule.vue?vue&type=script&lang=js"
export * from "./UpdateRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61871523",
  null
  
)

export default component.exports